import { formatMessage } from '@/utils/translationHelper';
import type { BreadcrumbProps } from '@/components/Breadcrumbs';
import type { Locale } from '@/i18n';
import { ReadonlyURLSearchParams } from 'next/navigation';
import { prepareNextUrl } from './urlHelper';

const COMMA = ', ';
const BASE_PATH = '/venues/results/';

type BreadcrumbUrlProps = {
  countryName: string | undefined;
  stateName: string | undefined;
  city: string | undefined;
  stateCode: string | undefined;
  countryCode: string | undefined;
  formattedSearchText: string | undefined;
  breadcrumbTexts: { homePageText: string; searchResultText: string };
  locale: Locale;
  BASE_PATH?: string;
  searchParams?: ReadonlyURLSearchParams | URLSearchParams | null;
};

type Props = {
  queryParserProps: BreadcrumbUrlProps;
};

function getBreadCrumbsDataForLocation({ queryParserProps }: Props) {
  const { countryName, stateName, city, countryCode, stateCode, locale, breadcrumbTexts } = queryParserProps;
  const breadcrumbs: BreadcrumbProps[] = [];
  breadcrumbs.push({ name: formatMessage(breadcrumbTexts.homePageText, locale), href: '/', isActive: true });
  if (countryName) {
    const pathName = `${BASE_PATH}${countryName}`;
    breadcrumbs.push({ name: countryName, href: prepareNextUrl('', pathName), isActive: true });
  }
  if (stateName) {
    const pathName = `${BASE_PATH}${encodeURIComponent(stateName + COMMA + countryCode)}`;
    breadcrumbs.push({
      name: stateName,
      href: prepareNextUrl('', pathName),
      isActive: true
    });
  }
  if (city) {
    const encodedTerm =
      stateCode && stateCode !== 'BLANK'
        ? encodeURIComponent(city + COMMA + stateCode + COMMA + countryCode)
        : encodeURIComponent(city + COMMA + countryCode);
    const pathName = `${BASE_PATH}${encodedTerm}`;
    breadcrumbs.push({
      name: city,
      href: prepareNextUrl('', pathName),
      isActive: true
    });
  }
  return breadcrumbs;
}

export function getSearchResultsPageBreadcrumbs({ queryParserProps }: Props): BreadcrumbProps[] {
  const { formattedSearchText, breadcrumbTexts, locale } = queryParserProps;

  const breadcrumbs = getBreadCrumbsDataForLocation({ queryParserProps });
  breadcrumbs.push({
    name: formatMessage(breadcrumbTexts.searchResultText, locale, { searchString: formattedSearchText }),
    href: '#',
    isActive: false
  });
  return breadcrumbs;
}
